"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SettingStorage = void 0;
var cookie_storage_item_1 = require("./cookie-storage-item");
var json_storage_item_1 = require("./json-storage-item");
var SettingStorage = (function () {
    function SettingStorage() {
        this.key = "evelin.settings";
        this.oneYearInSeconds = 60 * 60 * 24 * 365;
        this.storage = new json_storage_item_1.JsonStorageItem(new cookie_storage_item_1.CookieStorageItem(this.key, this.oneYearInSeconds));
    }
    SettingStorage.prototype.get = function () {
        var _a;
        return (_a = this.storage.get()) !== null && _a !== void 0 ? _a : {};
    };
    SettingStorage.prototype.setItem = function (key, value) {
        var _a;
        var setting = this.get();
        this.storage.set(__assign(__assign({}, setting), (_a = {}, _a[key] = value, _a)));
    };
    SettingStorage.prototype.removeItem = function (key) {
        var setting = this.get();
        delete setting[key];
        this.storage.set(setting);
    };
    SettingStorage.prototype.clear = function () {
        this.storage.remove();
    };
    return SettingStorage;
}());
exports.SettingStorage = SettingStorage;
//# sourceMappingURL=setting-storage.js.map